<script>
import { Bar } from "vue-chartjs";

export default {
  name: "BarGraph",
  extends: Bar,
  props: {
    labels: {
      type: Array,
      default: () => [],
    },
    datasets: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  mounted() {
    this.draw();
  },
  watch: {
    labels: {
      deep: true,
      handler() {
        if (this._isMounted) {
          this.draw();
        }
      },
    },
    datasets: {
      deep: true,
      handler() {
        if (this._isMounted) {
          this.draw();
        }
      },
    },
  },
  methods: {
    draw() {
      const labels = this.labels.length ? this.labels : ["No data"];
      const source = this.datasets.length
        ? this.datasets
        : [
            {
              label: "Messages",
              data: [],
              backgroundColor: "#9600bc",
              borderWidth: 1,
            },
          ];
      this.renderChart(
        {
          labels: labels,
          datasets: source.map(set => ({
            ...set,
            data: labels.map((_, index) =>
              set.data && set.data[index] != null ? set.data[index] : 0
            ),
            backgroundColor: Array.isArray(set.backgroundColor)
              ? set.backgroundColor.slice()
              : set.backgroundColor,
          })),
        },
        this.options
      );
    },
  },
};
</script>
